import { createSlice } from "@reduxjs/toolkit";
const youtubePosts = [
  {
    id: 1,
    title:
      "CLB doanh nhân đồng hương Bạc Liêu, Cà Mau tại TP. Cần Thơ đại hội lần 1",
    link: "https://www.youtube.com/watch?v=lVcUUhB6ajU",
  },
  {
    id: 2,
    title:
      "Họp mặt đồng hương Bạc Liêu - Cà Mau tại TP. Hồ Chí Minh và Cần Thơ",
    link: "https://www.youtube.com/watch?v=lVcUUhB6ajU",
  },
  {
    id: 3,
    title:
      "Thời sự Cà Mau tối 08.01 | Họp mặt đồng hương Cà Mau - Bạc Liêu tại Tp. Cần Thơ",
    link: "https://www.youtube.com/watch?v=lVcUUhB6ajU",
  },
];

const YoutubePostsSlice = createSlice({
  name: "youtube",
  initialState: {
    items: youtubePosts,
  },
  reducers: {
    addItem: (state, action) => {
      state.items.push(action.payload);
    },
    removeItem: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
  },
});

export const { addItem, removeItem } = YoutubePostsSlice.actions;
export default YoutubePostsSlice.reducer;
